import {useEffect, } from "react";
import {useSession} from "../hooks/useSession";
import {getShortName} from "../utils/helpers";
import {useConfig} from "../hooks/useConfig";

export default function GoogleSlidesExtensionAuth() {
    const {getSession, parseSessionToken} = useSession();
    const config = useConfig();



    useEffect(async () => {
        let {authorization} = getSession();
        let {institutionId } = parseSessionToken();
        let shortName = getShortName();


        let intervalId = null;
        let attemptCount = 0;

        if (!window.chrome) {
            return;
        }

        const cleanup = () => {
            if (intervalId !== null) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };


        const attemptSend = async () => {
            attemptCount++;
            if (!window.chrome.runtime) {
                // API not detected yet; fail the attempt to trigger retry.
                return false;
            }

            try {
                // chrome.runtime.sendMessage is asynchronous
                const response = await window.chrome.runtime.sendMessage(config.chrome_extension_id, {
                    type: "ENGAGE_AUTH_LOGIN",
                    enforced: false,
                    zone: config.zone,
                    shortName: shortName,
                    token: authorization,
                    institutionId
                });
                const lastError = window.chrome.runtime.lastError;

                if (lastError) {
                    console.log("send message error: ", lastError)
                    return false;
                }

                // SUCCESS!
                if (response.type === "ENGAGE_USER_INFO_RECEIVED") {
                    cleanup();
                }


                return true;

            } catch (error) {
                // console.warn("sendMessageToExtension error:", error);
                return false;
            }
        };

        const initialSuccess = await attemptSend();
        if (!initialSuccess) {
            intervalId = setInterval(attemptSend, 1000);
        }


        return () => {
            if (intervalId !== null) {
                clearInterval(intervalId);
                intervalId = null;
            }
        };

    }, []);


    return (<></>);
}